import { createSlice } from '@reduxjs/toolkit';
import { IAdminUser, IUserState } from '../../types/store';
import { IMenuItem } from '../../types/menu';

const initialState: IUserState = {
  roles: [],
  username: '',
  isLoggedIn: false,
  menuItems: [],
  isLoading: false,
  passwordExpired: false,
};

const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    login: (state, action) => {
      console.log(action.payload);
      state.roles = action.payload.user.roles;
      state.username = action.payload.user.username;
      state.isLoggedIn = true;
      state.passwordExpired = action.payload.user.password_expired;
    },
    logout: (state) => {
      state.isLoggedIn = false;
    },
    enableLoading: (state) => {
      state.isLoading = true;
    },
    disableLoading: (state) => {
      state.isLoading = false;
    },
    restoreSession: (state, action) => {
      const restoredUser: IAdminUser = JSON.parse(action.payload.user);
      const restoredMenuItems: IMenuItem[] = JSON.parse(action.payload.menuItems);
      state.isLoggedIn = true;
      state.username = restoredUser.username;
      state.roles = restoredUser.roles;
      state.menuItems = restoredMenuItems;
    },
    setUserNavigation: (state, action) => {
      state.menuItems = action.payload;
    },
    setPasswordExpired: (state, action) => {
      state.passwordExpired = action.payload;
    },
  },
});

export const {
  login,
  logout,
  enableLoading,
  disableLoading,
  restoreSession,
  setUserNavigation,
  setPasswordExpired,
} = userSlice.actions;

export default userSlice.reducer;
